import { IFocussedModule } from "containers/TalkToExpert/meetingTypes";
import { isEqual, isNumber, round } from "lodash";
import { LocationType } from "types/OnboardCandidate";

export function extractParams(params: any) {
  if (params[0] === '?') params = params.slice(1)

  return params
    .split('&')
    .reduce((acc: any, curr: any) => {
      const param = curr.split('=');
      return { [param[0]]: param[1], ...acc }
    }, {})
}

export const getUUIDFromURL = (path: string) => {
  return path.substring(path.lastIndexOf('/') + 1);
}

export const getFileNameFromURL = (url: string) => {
  if (url) {
    const tempArr = url.split(".");
    let ext;
    if (tempArr[tempArr.length - 1].length) {
      ext = tempArr[tempArr.length - 1];
    }
    var m = url.toString().match(/.*\/(.+?)\./);
    if (m && m.length > 1) {
      return m[1] + "." + ext;
    }
  }
  return "";
}

export const removeUnwantedTextFromFileName = (url: string) => {
  let name = getFileNameFromURL(url);
  return remUnWanTxtHelper(name);
}

export const getFolderPathAfterDomainName = (url: string) => {
  if (!url) return url;
  if (!url.includes(".com/")) {
    return decodeURIComponent(url);
  }
  return remUnWanTxtHelper(url?.split(".com/")[1]);
}

export const convertHttpsToHttpFromUrl = (url: string) => {
  if (url == null) return url;
  return "http" + url.substring(url.indexOf(':'), url.length);
}

export const downloadFile = (folderPath: string) => {
  const link = document.createElement('a');
  link.href = folderPath;
  link.setAttribute('download', '');
  document.body.appendChild(link);
  link.click();
}

export const extractTextFromHTML = (htmlString: string) => {
  let plainText = htmlString.replace(/<[^>]+>/g, ' ');
  return plainText;
}

const remUnWanTxtHelper = (name: string) => {
  let index = name?.indexOf("?");
  return decodeURIComponent(name?.substring(0, index == -1 ? name.length : index));
}

export const getTreeCheckedKeys = (treeData: IFocussedModule[]) => {
  const keys: string[] = [];
  for (let i = 0; i < treeData.length; i++) {
    const cat = treeData[i];
    !cat.children?.length && keys.push(cat.entityId + "-" + cat.entity);
    for (let j = 0; j < cat.children?.length; j++) {
      const subcat = cat.children[j];
      !subcat.children?.length && keys.push(cat.entityId + "-" + cat.entity + "-" + subcat.entityId + "-" + subcat.entity);
      for (let k = 0; k < subcat.children?.length; k++) {
        const cap = subcat.children[k];
        !cap.children?.length && keys.push(cat.entityId + "-" + cat.entity + "-" + subcat.entityId + "-" + subcat.entity + "-" + cap.entityId + "-" + cap.entity);
        for (let l = 0; l < cap.children?.length; l++) {
          const ques = cap.children[l];
          keys.push(cat.entityId + "-" + cat.entity + "-" + subcat.entityId + "-" + subcat.entity + "-" + cap.entityId + "-" + cap.entity + "-" + ques.entityId + "-" + ques.entity)
        }
      }
    }
  }
  return keys;
}

export function formatNumberToShortenedForm(number: number) {
  if (!isNumber(number)) {
    return null; // Return null if the input is not a number
  }
  if (number >= 1000000) {
    return `${round(number / 1000000, 1)}M`; // For millions (e.g., 2.5M)
  } else if (number >= 1000) {
    return `${round(number / 1000, 1)}k`; // For thousands (e.g., 50k)
  } else {
    return `${number}`; // Return the number as is if it's less than 1000
  }
}

export const getLocations = (locations: LocationType[]): string[] => {
  if (!locations || locations.length === 0) {
    return ['-'];
  }
  const locationStrings = [];
  for (let location of locations) {
    const tempArr = [];
    location.countryName && tempArr.push(location.countryName);
    location.state?.stateName && tempArr.push(location.state?.stateName);
    location.state?.city?.cityId && tempArr.push(location.state?.city?.cityId);
    locationStrings.push(tempArr.join(', '));
  }
  return locationStrings;
}

export function triggerDownload(url: string) {
  const link = document.createElement('a');
  link.href = url;
  link.style.display = 'none'; // Hide the link element
  document.body.appendChild(link);

  // Programmatically trigger the download
  link.click();

  // Clean up
  document.body.removeChild(link);
}

export async function hasAudioPermission(): Promise<boolean> {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    return true;
  } catch (error) {
    return false;
  }
}

export function getRandomString(): string {
  const random1 = Math.random();
  const random2 = Math.random();
  const date = new Date();
  return random1 + "_" + random2 + "_" + date.getTime();
}


export function secondObjectIsMatch(
  obj1: any,
  obj2: any
): boolean {
  if (Array.isArray(obj2)) {
    return isEqual(obj1, obj2);
  }

  if (typeof obj1 === 'object' && obj1 !== null && typeof obj2 === 'object' && obj2 !== null) {
    const keys = Object.keys(obj2);

    for (const key of keys) {
      if (!isEqual(obj2[key], obj1[key])) {
        return false;
      }
    }
  }

  return isEqual(obj1, obj2);
}

export const getScrollValue = (child: HTMLElement, parent: HTMLElement): number => {
  // Get the bounding rectangles of the child and parent elements
  const childRect = child.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();

  // Calculate the position of the child relative to the parent
  return childRect.top - parentRect.top + parent.scrollTop - 50;
};